import React from 'react';

interface ConfigFieldProps {
  label: string;
  description?: string;
  required?: boolean;
  children: React.ReactNode;
}

/**
 * Consistent field wrapper for config forms.
 * Renders label above the field with optional description below.
 */
export function ConfigField({ label, description, required, children }: ConfigFieldProps) {
  return (
    <div className="space-y-1.5">
      <label className="text-sm font-medium text-foreground">
        {label}
        {required && <span className="text-destructive ml-1">*</span>}
      </label>
      {children}
      {description && (
        <p className="text-xs text-muted-foreground leading-relaxed">{description}</p>
      )}
    </div>
  );
}
